var exports = {
  "o": "x93eb46d8--2010ac--legend",
};

module.exports = exports;
